export default __webpack_public_path__ + "static/media/480_business04-en-mobile.556f85f9.png";